<div
  class="feature-container"
  [ngClass]="{ 'new-container': isMorning }"
  #featureContainer
>
  <div class="feature-text" [ngClass]="{ 'new-left': isMorning }">
    <div class="sticky-header">
      <img [src]="logo" />
      <h2>
        <span>{{ heading }} </span>
        <span class="highlight">{{ highlight }}</span>
      </h2>
    </div>
    <!-- <div class="description-wrapper" *ngFor="let text of points">
      <span class="bullet">▹</span>
      <span [innerHTML]="text" class="des-text"></span>
    </div>
    <a [routerLink]="link">{{ linkText }}</a> -->
    <div class="carousel-container">
      <div
        *ngFor="let card of data; let i = index"
        class="card"
        [ngClass]="{
          blueBg: card.shape === 'square',
          greenBg: card.shape === 'triangle',
          yellowBg: card.shape === 'circle'
        }"
      >
        <div class="card-content">
          <!-- <div class="card-icon">{{ card.icon }}</div> -->
          <div
            class="shape-container"
            [ngClass]="{
              square: card.shape === 'square',
              triangle: card.shape === 'triangle',
              circle: card.shape === 'circle'
            }"
          ></div>
          <!-- <p *ngIf="card.description" class="card-description">{{ card.description }}</p> -->
          <span [innerHTML]="card.description" class="des-text"></span>
          <div class="button-container">
            <button [ngClass]="'btn-' + card.buttonColor">
              {{ card.buttonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="feature-image" [ngClass]="{ 'new-right': isMorning }">
    <img [src]="imageLink" alt="image" #featureImage />
  </div>
</div>
